import type { ValuesUnion } from "@regrello/core-utils";

export const RegrelloIntent = {
  /** Error or destructive action. */
  DANGER: "danger" as const,

  /** Default, unopinionated UI. */
  NEUTRAL: "neutral" as const,

  /** Main action or highlight. */
  PRIMARY: "primary" as const,

  /** Exciting, noteworthy, typically AI-related. */
  SPECIAL: "special" as const,

  /** Positive or expected outcome. */
  SUCCESS: "success" as const,

  /** Caution or time-sensitive info. */
  WARNING: "warning" as const,
};

export type RegrelloIntent = ValuesUnion<typeof RegrelloIntent>;
